import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, ButtonBase, ThemeProvider, TextField, IconButton, InputAdornment, Dialog, DialogContent, Button } from '@mui/material';
import { ThemeContext } from './ThemeContext';
import ThemeToggle from './ThemeToggle';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import urbanImage from './assets/urban.jpg';
import ruralImage from './assets/rural.jpg';
import axios from 'axios';
import config from './config';

const SelectionScreen = () => {
  const { theme } = useContext(ThemeContext);
  const navigate = useNavigate();
  const [matricula, setMatricula] = useState('');
  const [error, setError] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMatricula, setDialogMatricula] = useState('');
  const [dialogType, setDialogType] = useState(null);

  const handleOpenDialog = (type) => {
    setDialogType(type);
    setDialogMatricula('');
    setError(null);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setDialogMatricula('');
    setDialogType(null);
    setError(null);
  };

  const handleConfirmMatricula = async () => {
    if (!dialogMatricula || isNaN(dialogMatricula)) {
      setError('Por favor, insira uma matrícula válida.');
      return;
    }

    localStorage.setItem('matricula', dialogMatricula);
    handleCloseDialog();

    if (dialogType === 'urban') {
      await handleUrban();
    } else if (dialogType === 'rural') {
      await handleRural();
    }
  };

  const handleUrban = async () => {
    try {
      const token = localStorage.getItem('token');
      const userDataResponse = await axios.get(`${config.API_URL}/user-data`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const userData = userDataResponse.data;
      userData.cidades = userData.cidades.filter(cidade => cidade.URBANO_RURAL === 1);
      userData.bairros = userData.bairros.filter(bairro => bairro.URBANO_RURAL === 1);
      localStorage.setItem('userData', JSON.stringify(userData));
      limparImovelFormData();
      navigate('/map');
    } catch (error) {
      console.error('Erro ao buscar dados urbanos:', error.response || error.message);
      alert('Erro: ' + (error.response?.data?.detail || error.message));
    }
  };

  const handleRural = async () => {
    try {
      const token = localStorage.getItem('token');
      const userDataResponse = await axios.get(`${config.API_URL}/user-data`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const userData = userDataResponse.data;
      userData.cidades = userData.cidades.filter(cidade => cidade.URBANO_RURAL === 1);
      userData.bairros = userData.bairros.filter(bairro => bairro.URBANO_RURAL === 2);
      localStorage.setItem('userData', JSON.stringify(userData));
      limparImovelFormData();
      navigate('/rural');
    } catch (error) {
      console.error('Erro ao buscar dados rurais:', error.response || error.message);
      alert('Erro: ' + (error.response?.data?.detail || error.message));
    }
  };

  const limparImovelFormData = () => {
    localStorage.removeItem('imovelFormData');
    localStorage.removeItem('mapAreas');
    localStorage.removeItem('mapPolygons');
  };

  const handleFetchCalculation = async () => {
    if (!matricula || isNaN(matricula)) {
      setError('Por favor, insira um ID de cálculo válido.');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${config.API_URL}/historico-calculo/${matricula}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const inputJson = response.data.input_json;
      if (!inputJson) {
        setError('Nenhum dado encontrado para o ID fornecido.');
        return;
      }

      localStorage.setItem('imovelFormData', JSON.stringify({
        imovelData: { cubc: [], vida_util: [], grau_cons: [], mercado: [] },
        areaLote: inputJson.area_lote || '',
        areaConstruida: inputJson.area_construida || '',
        idadeAparente: inputJson.idade_aparente || '',
        valorInformado: inputJson.valor_informado || '',
        selectedVidaUtil: inputJson.id_vida_util || '',
        selectedGrauCons: inputJson.id_grau_cons || '',
        selectedCUBC: inputJson.id_cubc || '',
        selectedMercado: inputJson.id_mercado || '',
        clientes: inputJson.clientes || [{ nome: '', cpf: '', endereco: '', telefone: '' }],
        currentCidade: inputJson.id_cidade || '',
        currentBairro: inputJson.id_bairro || '',
        currentEndereco: inputJson.id_endereco || '',
        observations: inputJson.observacoes || '',
        matricula: inputJson.matricula || '',
      }));

      localStorage.setItem('mapPolygons', JSON.stringify(inputJson.mapPolygons || []));
      localStorage.setItem('mapAreas', JSON.stringify(inputJson.mapAreas || []));

      if (inputJson.urbano_rural === 1) {
        try {
          const token = localStorage.getItem('token');
          const userDataResponse = await axios.get(`${config.API_URL}/user-data`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          const userData = userDataResponse.data;
          userData.cidades = userData.cidades.filter(cidade => cidade.URBANO_RURAL === 1);
          userData.bairros = userData.bairros.filter(bairro => bairro.URBANO_RURAL === 1);
          localStorage.setItem('userData', JSON.stringify(userData));
          navigate('/map', {
            state: {
              selectedMunicipioId: inputJson.id_municipio || '',
              selectedCidade: inputJson.id_cidade || '',
              selectedBairro: inputJson.id_bairro || '',
              selectedEndereco: inputJson.id_endereco || '',
              addressInput: '',
              calculationData: inputJson,
            },
          });
        } catch (error) {
          console.error('Erro ao buscar dados urbanos:', error.response || error.message);
          alert('Erro: ' + (error.response?.data?.detail || error.message));
        }
      } else {
        try {
          const token = localStorage.getItem('token');
          const userDataResponse = await axios.get(`${config.API_URL}/user-data`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          const userData = userDataResponse.data;
          userData.cidades = userData.cidades.filter(cidade => cidade.URBANO_RURAL === 1);
          userData.bairros = userData.bairros.filter(bairro => bairro.URBANO_RURAL === 2);
          localStorage.setItem('userData', JSON.stringify(userData));
          navigate('/rural', {
            state: {
              selectedMunicipioId: inputJson.id_municipio || '',
              selectedCidade: inputJson.id_cidade || '',
              selectedBairro: inputJson.id_bairro || '',
              selectedEndereco: inputJson.id_endereco || '',
              addressInput: '',
              calculationData: inputJson,
            },
          });
        } catch (error) {
          console.error('Erro ao buscar dados rurais:', error.response || error.message);
          alert('Erro: ' + (error.response?.data?.detail || error.message));
        }
      }
    } catch (error) {
      console.error('Erro ao buscar cálculo:', error.response || error.message);
      setError('Erro ao buscar cálculo: ' + (error.response?.data?.detail || error.message));
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          backgroundColor: 'background.default',
          alignItems: 'center',
          justifyContent: 'center',
          p: 4,
          gap: 4,
          position: 'relative', // Para posicionar o botão de fechar
        }}
      >
        <Typography variant="h4" sx={{ color: 'text.primary', mb: 4 }}>
          Selecione o Tipo de Área
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 4,
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            maxWidth: 800,
          }}
        >
          <ButtonBase
            onClick={() => handleOpenDialog('urban')}
            sx={{
              flex: 1,
              maxWidth: 350,
              borderRadius: 2,
              overflow: 'hidden',
              boxShadow: 3,
              transition: 'transform 0.3s ease',
              '&:hover': {
                transform: 'scale(1.05)',
              },
            }}
          >
            <Box
              component="img"
              src={urbanImage}
              alt="Área Urbana"
              sx={{
                width: '100%',
                height: 200,
                objectFit: 'cover',
              }}
            />
            <Typography
              variant="h6"
              sx={{
                position: 'absolute',
                bottom: 10,
                color: 'white',
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                width: '100%',
                textAlign: 'center',
                py: 1,
              }}
            >
              Área Urbana
            </Typography>
          </ButtonBase>
          <ButtonBase
            onClick={() => handleOpenDialog('rural')}
            sx={{
              flex: 1,
              maxWidth: 350,
              borderRadius: 2,
              overflow: 'hidden',
              boxShadow: 3,
              transition: 'transform 0.3s ease',
              '&:hover': {
                transform: 'scale(1.05)',
              },
            }}
          >
            <Box
              component="img"
              src={ruralImage}
              alt="Área Rural"
              sx={{
                width: '100%',
                height: 200,
                objectFit: 'cover',
              }}
            />
            <Typography
              variant="h6"
              sx={{
                position: 'absolute',
                bottom: 10,
                color: 'white',
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                width: '100%',
                textAlign: 'center',
                py: 1,
              }}
            >
              Área Rural
            </Typography>
          </ButtonBase>
        </Box>
        <ThemeToggle sx={{ mt: 4 }} />
        <Box sx={{ mt: 2, width: '100%', maxWidth: 400 }}>
          <TextField
            fullWidth
            label="Matrícula"
            variant="outlined"
            type="number"
            value={matricula}
            onChange={(e) => {
              setMatricula(e.target.value);
              setError(null);
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter' && matricula && !isNaN(matricula)) {
                handleFetchCalculation();
              }
            }}
            inputProps={{ min: 1 }}
            error={!!error}
            helperText={error}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleFetchCalculation}
                    disabled={!matricula || isNaN(matricula)}
                    sx={{
                      backgroundColor: 'primary.main',
                      color: 'white',
                      borderRadius: '8px',
                      p: 1,
                      '&:hover': {
                        backgroundColor: 'primary.dark',
                      },
                      '&:disabled': {
                        backgroundColor: 'grey.400',
                        color: 'grey.600',
                      },
                    }}
                  >
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
              '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                display: 'none',
              },
              '& input[type=number]': {
                MozAppearance: 'textfield',
              },
            }}
          />
        </Box>
        <Dialog
          open={dialogOpen}
          onClose={handleCloseDialog}
          PaperProps={{
            sx: {
              borderRadius: 2,
              padding: 2,
              width: '100%',
              maxWidth: 400,
              boxShadow: 10,
            },
          }}
          BackdropProps={{
            sx: {
              backgroundColor: 'rgba(0, 0, 0, 0.9)', // Fundo com alpha (transparente)
            },
          }}
        >
          <DialogContent sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              autoFocus
              fullWidth
              label="Matrícula"
              type="number"
              variant="outlined"
              value={dialogMatricula}
              onChange={(e) => {
                setDialogMatricula(e.target.value);
                setError(null);
              }}
              onKeyPress={(e) => {
                if (e.key === 'Enter' && dialogMatricula && !isNaN(dialogMatricula)) {
                  handleConfirmMatricula();
                }
              }}
              error={!!error}
              helperText={error}
              inputProps={{ min: 1 }}
              sx={{
                '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                  display: 'none',
                },
                '& input[type=number]': {
                  MozAppearance: 'textfield',
                },
              }}
            />
            <Button
              onClick={handleConfirmMatricula}
              disabled={!dialogMatricula || isNaN(dialogMatricula)}
              variant="contained"
              fullWidth
              sx={{
                mt: 1,
                py: 1.5,
                borderRadius: 1,
              }}
            >
              Confirmar
            </Button>
          </DialogContent>
        </Dialog>
        {dialogOpen && (
          <IconButton
            onClick={handleCloseDialog}
            sx={{
              position: 'fixed',
              top: 16,
              right: 16,
              color: 'white',
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.8)',
              },
              zIndex: 2000, // Acima do diálogo
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </Box>
    </ThemeProvider>
  );
};

export default SelectionScreen;